<template>
  <div class="conversation-tab-container d-flex flex-column" style="border-left:1px solid #e0e4e8 ">

    <div style="border-bottom:1px solid #e0e4e8" class="msg-header d-flex align-items-center ">
      <div class="d-flex flex-1">
        <div v-for="tab in getTabs()" :key="tab.val" class="flex-1">
          <el-tag
            @click="handleSelectTab(tab.val)"
            v-bind:style="tab.val === selectedTab ? activeMenuStyle : normalMenuStyle"
            effect="dark"
            style="height:40px;"
            class="pointer text-center pt-1   my-2 fw-semibold font-size-14 d-flex justify-content-center">
            <div>{{ tab.name }}</div>
          </el-tag>
        </div>
      </div>
    </div>
    <div v-if="selectedTab===2 ">
      <CreateOrder :conversation="conversation" />
    </div>
    <div v-if="selectedTab===1">
      <CustomerInfo v-if="!conversation.group" :conversation="conversation" />
      <MemberTab v-else :conversation="conversation" />
    </div>
    <div class="d-flex flex-column p-2" v-if="selectedTab===3 ">
      <InformationConversation :key="conversation.id" :conversation="conversation" />
    </div>
    <div v-if="selectedTab===4 ">
      <OrderHistory :conversation="conversation" />
    </div>
  </div>
</template>

<script>
import CustomerInfo from "./CustomerInfo";
import InformationConversation from "./InformationConversation/InformationConversation";
import MemberTab from "./InformationConversation/MemberTab";
import CreateOrder from "./InformationConversation/CreateOrder";
import OrderHistory from "./InformationConversation/OrderHistory";

export default {
  components: { OrderHistory, MemberTab, InformationConversation, CustomerInfo, CreateOrder },
  props: ["conversation"],

  computed: {
    activeMenuStyle() {
      return {
        "border-radius": "4px",
        border: "0px solid",
        color: "#0A58C0",
        "background-color": this.setTransparencyHex("#0A58C0", 0.08),
        margin: "1px 4px 3px 1px"
      };
    },
    normalMenuStyle() {
      return {
        "border-radius": "4px",
        border: "0px solid",
        color: "#696B72",
        "background-color": "transparent",
        margin: "1px 4px 3px 1px"
      };
    }
  },
  data() {
    return {
      index: 0,
      noMore: false,
      images: [],
      ts: "",
      tabs: [
        { name: "Tệp", val: 3 },
        { name: "Liên hệ", val: 1 },
        { name: "Lên đơn", val: 2 },
        { name: "Lịch sử", val: 4 }
      ],
      selectedTab: 3
    };
  },
  methods: {
    getTabs() {
      if (this.conversation.group) {
        this.tabs[1].name = "Thành viên";
      } else {
        this.tabs[1].name = "Liên hệ";
      }
      // if (this.conversation.group)
      //   return this.tabs.filter(s =>
      //     ![2, 4].includes(s.val)
      //   );
      return this.tabs;
    },
    handleSelectTab(val) {
      if (val === 3 && this.selectedTab !== 3) {
        this.index++;
      }
      this.selectedTab = val;
    }
  },
  created() {
    this.selectedTab = 3;
  }
};
</script>
